<template>
  <div class="content">
    <!-- 头部部分 -->
    <div class="head">
      <!-- 展示的搜索条件 -->
      <div class="searchOne">
        <el-select v-model="queryParams.appId" filterable placeholder="公众号" @change="search" clearable>
          <el-option v-for="item in wechats" :key="item.label" :label="item.value" :value="item.label"></el-option>
        </el-select>
        <el-input v-model="queryParams.nickname" placeholder="昵称"  @keyup.enter.native="search" clearable></el-input>
        <el-input v-model="queryParams.userId" placeholder="微信UserId"  @keyup.enter.native="search" clearable></el-input>
      </div>
      <!-- 搜索的按钮 -->
      <span class="span-but">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
      </span>
      <!-- 隐藏的搜索条件 -->
      <div v-show="an" class="array-class">
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="content-class">
      <div style="margin-top: 10px">
        <el-table :data="tableData" border >
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
          <el-table-column prop="imagUrl" label="图像" align="center">
            <template slot-scope="{row}">
              <el-image v-if="!!row.imagUrl"
                style="width: 50px; height: 50px"
                :src="row.imagUrl"
                fit="fill"
                :preview-src-list="[row.imagUrl]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="openId" label="OpenId" align="center" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column prop="wxUserId" label="微信UserId" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="subscribe" label="是否关注" align="center" >
            <template slot-scope="{row}">
              <span v-if="row.subscribe =='1'">关注</span>
              <span v-else>取消关注</span>
            </template>
          </el-table-column>
          <el-table-column prop="subscribeScene" label="关注渠道" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="appName" label="来源公众号" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { userWxList } from "@/api/api.js"; //用户列表获取初始化数据
export default {
  name: "userList",
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      sortOrder:"",
      sortName:"",
      // searchTime:[],
      wechats:[
        { label: "wx45ca3764ee7e7a36",value: '桔子智联', },
        { label: "wxda58efa17720fffd",value: '桔子智联云', },
        { label: "wx00dcd871376f83ea",value: '桔子智联中心', },
        { label: "wxf93145053d7fd7f4",value: '前海云领', }
      ],
    }
  },
  methods: {
    hidden(){
      this.an = this.an == false ? true : false
    },
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      userWxList(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
            item.phone = item.phone == null ? "-" : item.phone;
            item.scene = item.scene == null ? "-" : item.scene;
            this.total = res.data.data.total;
          })
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      }
      this.searchTime = [];
      this.initData();
    },
    
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },

  },
  created() {
    this.initData();
  },
  mounted() {

  },

};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
</style>


